import i18next from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import XHR from "i18next-http-backend"

import { resources } from "translations"

const isJestEnvironment = process.env.JEST_WORKER_ID !== undefined

export const ENGLISH_CODE = "gb"
export const FRENCH_CODE = "fr"
export const GERMAN_CODE = "de"
export const SPANISH_CODE = "es"

if (isJestEnvironment) {
	// console.log("jest i18n activated")
	// Init in cimode for Jest (t => t)
	i18next.init({
		lng: "cimode",
		fallbackLng: "cimode",
		interpolation: {
			escapeValue: false,
		},
	})
} else {
	i18next
		.use(XHR)
		.use(LanguageDetector)
		.use(initReactI18next)
		.init({
			resources,
			lng: localStorage.getItem("i18nextLng") || "fr",
			fallbackLng: (code: string) => {
				if (["en"].includes(code)) return [ENGLISH_CODE]
				return [FRENCH_CODE]
			},
			supportedLngs: [
				FRENCH_CODE,
				ENGLISH_CODE,
				GERMAN_CODE,
				SPANISH_CODE,
				"fr-FR",
				"en",
				"en-UK",
			],
			detection: {
				caches: ["localStorage", "cookie"],
				order: ["navigator", "localStorage", "cookie", "sessionStorage"],
			},

			interpolation: {
				escapeValue: false,
			},
		})
}

export const getLanguage = () => {
	return (
		i18next.language ||
		(typeof window !== "undefined" && window.localStorage.i18nextLng) ||
		"fr"
	)
}

export const isEnglishLanguage = () => {
	return getLanguage() === ENGLISH_CODE || getLanguage() === "en"
}

export const isFrenchLanguage = () => {
	return getLanguage() === FRENCH_CODE || getLanguage() === "fr-FR"
}

export const isGermanLanguage = () => {
	return getLanguage() === GERMAN_CODE
}

export const isSpanishLanguage = () => {
	return getLanguage() === SPANISH_CODE
}

export default i18next
